"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _requireAsync = _interopRequireDefault(require("customer-data-ui-utilities/async/requireAsync"));

/**
 * `RichTextEditableComponent` renders a `BaseComponent` that requires
 * `RichTextEditorModules`. Those modules will be required asynchonously and
 * passed as props to `BaseComponent`.
 *
 * @param  {ReactComponent} BaseComponent
 * @param  {Seq} richTextEditorModules
 * @return {ReactComponent}
 */
var _default = function _default(BaseComponent, richTextEditorModules) {
  var RichTextEditableComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(RichTextEditableComponent, _Component);

    function RichTextEditableComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, RichTextEditableComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditableComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        pending: true
      };
      return _this;
    }

    (0, _createClass2.default)(RichTextEditableComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        (0, _requireAsync.default)(this, richTextEditorModules).then(this.handleAsyncRequire, _emptyFunction.default).done();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelAsyncRequire();
      }
    }, {
      key: "handleAsyncRequire",
      value: function handleAsyncRequire(modules) {
        this.setState({
          modules: modules,
          pending: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.pending) {
          return null;
        }

        return _react.default.createElement(BaseComponent, (0, _extends2.default)({}, this.props, this.state.modules));
      }
    }]);
    return RichTextEditableComponent;
  }(_react.Component);

  RichTextEditableComponent.WrappedComponent = BaseComponent;
  RichTextEditableComponent.displayName = "RichTextEditable(" + BaseComponent.displayName + ")";
  return RichTextEditableComponent;
};

exports.default = _default;
module.exports = exports.default;